<template>
  <vue-countdown-timer
    @start_callback="startCallBack('event started')"
    @end_callback="endCallBack('event ended')"
    :start-time="startDate"
    :end-time="endTime"
    :interval="1000"
    :start-label="''"
    :end-label="''"
    label-position="begin"
    :end-text="''"
    :day-txt="''"
    :hour-txt="''"
    :minutes-txt="''"
    :seconds-txt="''">

    <template slot="countdown" slot-scope="scope">
      <span>{{scope.props.minutes}}</span><i>{{scope.props.minutesTxt}}</i> : 
      <span>{{scope.props.seconds - parseFloat(scope.props.minutes * 60)}}</span><i>{{scope.props.secondsTxt}}</i>
    </template>
  </vue-countdown-timer>
</template>

<script >
import moment from 'moment'
export default {
  name: 'Timer',
  props : {
    valDate : {  // pass date object till when you want to run the timer
      type : Date,
      default(){
        return new Date()
      }
    },
  },
  data() {
    return {
      startDate: null,
      endTime: 0,
      output: ''
    }
  },
  watch: {
    valDate(val) {
      if (val) {
        this.startDate = moment(val).format('Y-M-D h:m:s')
        let ET = moment(new Date(val)).add(5, 'm').format('Y-M-D h:m:s')
        this.endTime = new Date(ET).getTime()
      }
    },
  },
  methods: {
    startCallBack: function(x) {
      this.output = x
      this.$emit('action', 1)
    },
    endCallBack: function(x) {
      this.output = x
      this.$emit('action', 0)
    },
  },
};
</script>